import React from "react";
import { defaultButtonText, defaultHeaderTitleText } from "./constants";
import { emptyFunction, emptySetterFunction } from "@utils/helpers/emptyFunction";

export const FormContext = React.createContext({
  button: {
    getOnSubmit: emptyFunction,
    setOnSubmit: emptySetterFunction,
    buttonText: defaultButtonText,
    setButtonText: emptySetterFunction,
    hidden: false,
    setHidden: emptySetterFunction,
  },
  header: {
    title: defaultHeaderTitleText,
    setTitle: emptySetterFunction,
  }
});